export default "__VITE_ASSET__DjUR$7sD__"